<template><div><code-well-header class="d-d-block">
  <dt-button-group alignment="start" class="d-g8">
    <dt-button importance="primary">Confirm</dt-button>
    <dt-button importance="outlined">Cancel</dt-button>
  </dt-button-group>
</code-well-header>
<code-example-tabs
htmlCode='
<div role="group" class="d-btn-group d-btn-group--start" alignment="start">
  <button type="button" class="base-button__button d-btn d-btn--primary">
    <span class="d-btn__label base-button__label"> Confirm </span>
  </button>
  <button data-qa="dt-button" type="button" class="base-button__button d-btn d-btn--outlined">
    <span class="d-btn__label base-button__label"> Cancel </span>
  </button>
</div>
'
vueCode='
<dt-button-group>
  <dt-button importance="primary">Confirm</dt-button>
  <dt-button importance="outlined">Cancel</dt-button>
</dt-button-group>
'
showHtmlWarning />
<h2 id="variants" tabindex="-1" class="d-docsite--header-2">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">The alignment and the order of buttons within it can be customized to suit the specific use case.</p>
<h3 id="start" tabindex="-1" class="d-docsite--header-3">Start <a class="header-anchor d-link d-docsite--link d-link" href="#start" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">When aligned to <code v-pre>start</code>, the <code v-pre>primary</code> button is on the <strong>left</strong> side of the group.</p>
<code-well-header class="d-d-block">
  <dt-button-group alignment="start" class="d-g8">
    <dt-button importance="primary">Confirm</dt-button>
    <dt-button importance="outlined">Cancel</dt-button>
  </dt-button-group>
</code-well-header>
<code-example-tabs
htmlCode='
<div role="group" class="d-btn-group d-btn-group--start" alignment="start">
  <button type="button" class="base-button__button d-btn d-btn--primary">
    <span class="d-btn__label base-button__label"> Confirm </span>
  </button>
  <button data-qa="dt-button" type="button" class="base-button__button d-btn d-btn--outlined">
    <span class="d-btn__label base-button__label"> Cancel </span>
  </button>
</div>
'
vueCode='
<dt-button-group>
  <dt-button importance="primary">Confirm</dt-button>
  <dt-button importance="outlined">Cancel</dt-button>
</dt-button-group>
'
showHtmlWarning />
<h3 id="end" tabindex="-1" class="d-docsite--header-3">End <a class="header-anchor d-link d-docsite--link d-link" href="#end" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">When aligned to <code v-pre>end</code>, the <code v-pre>primary</code> button is on the <strong>right</strong> side of the group.</p>
<code-well-header class="d-d-block">
  <dt-button-group alignment="end" class="d-g8">
    <dt-button importance="outlined">Cancel</dt-button>
    <dt-button importance="primary">Confirm</dt-button>
  </dt-button-group>
</code-well-header>
<code-example-tabs
htmlCode='
<div role="group" class="d-btn-group d-btn-group--end">
  <button type="button" class="base-button__button d-btn d-btn--primary">
    <span class="d-btn__label base-button__label"> Confirm </span>
  </button>
  <button data-qa="dt-button" type="button" class="base-button__button d-btn d-btn--outlined">
    <span class="d-btn__label base-button__label"> Cancel </span>
  </button>
</div>
'
vueCode='
<dt-button-group alignment="end">
  <dt-button importance="primary">Confirm</dt-button>
  <dt-button importance="outlined">Cancel</dt-button>
</dt-button-group>
'
showHtmlWarning />
<h3 id="space-between" tabindex="-1" class="d-docsite--header-3">Space-Between <a class="header-anchor d-link d-docsite--link d-link" href="#space-between" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">When set to <code v-pre>space-between</code>, the elements are evenly distributed within the row, creating a directional flow where the <code v-pre>primary</code> button is either on the <strong>left</strong> (regressive) or on the <strong>right</strong> (progressive).</p>
<code-well-header class="d-d-block">
  <dt-button-group alignment="space-between" class="d-g8">
    <dt-button importance="outlined">Previous</dt-button>
    <dt-button importance="primary">Next</dt-button>
  </dt-button-group>
</code-well-header>
<code-example-tabs
htmlCode='
<div role="group" class="d-btn-group d-btn-group--space-between">
  <button data-qa="dt-button" type="button" class="base-button__button d-btn d-btn--outlined">
    <span class="d-btn__label base-button__label"> Previous </span>
  </button>
  <button type="button" class="base-button__button d-btn d-btn--primary">
    <span class="d-btn__label base-button__label"> Next </span>
  </button>
</div>
'
vueCode='
<dt-button-group alignment="space-between">
  <dt-button importance="outlined">Previous</dt-button>
  <dt-button importance="primary">Next</dt-button>
</dt-button-group>
'
showHtmlWarning />
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="buttongroup" /></div></template>


